module.exports = __webpack_public_path__ + "static/media/1f5e3.c353bf8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f5e3.svg
// module id = 639
// module chunks = 1